import React, { useState } from 'react';
import { Newspaper, Calendar, ExternalLink } from 'lucide-react';
import Footer from '../components/Footer';

const PressPage = () => {
  const [previewImage, setPreviewImage] = useState(null);

  const pressReleases = [
    {
      id: 1,
      title: "Certificate Of Merit",
      date: "2023",
      summary: "M/s Aaj Engineers & Consultants Pvt. Ltd., Nagpur has been honored with the prestigious ICI (Nagpur)–UltraTech Award 2023 for Outstanding Concrete Structure of Vidarbha Region in the Residential–Flats Scheme (Height < 15 m) category.",
      image: "/aaj-home/certificate1.jpeg",
    },
    {
      id: 2,
      title: "Certificate of Participate (VNIT)",
      date: "2025",
      summary: "This Certificate of Participation was awarded to Ashish Shivarkar for successfully attending a workshop on “Understanding IS 1893:2025 (Part 1 & Part 5)”, organized by the Department of Applied Mechanics, Visvesvaraya National Institute of Technology (VNIT), Nagpur. ",
      image: "/aaj-home/certificate-ashishsir.jpeg",
    },
    {
      id: 3,
      title: "Certificate of Participate (VNIT)",
      date: "2025",
      summary: "This Certificate of Participation was awarded to Aman Kumar Sigh for successfully attending a workshop on “Understanding IS 1893:2025 (Part 1 & Part 5)”, organized by the Department of Applied Mechanics, Visvesvaraya National Institute of Technology (VNIT), Nagpur.",
      image: " /aaj-home/aman-sir-certificate.jpeg ",
    },
      {
      id: 4,
      title: "ICI (Nagpur) - UltraTech Award for Outstanding Concrete Structure of Vidarbha 2012.",
      date: "2012",
      summary: " Indian Concrete Institute & UltraTech Cement Limited recognizes and appreciates your work as a Structural Consultant for the residence of Mr. Yogendra Singh located at Nagpur. ",
      image: "/aaj-home/certificate3.jpeg",
    },
      {
      id: 5,
      title: "ICI (Nagpur) - LiltraTech Award",
      date: "2017",
      summary: "In recognition of being the Structural Consultant for the project Residential Bungalow of Dr. Umesh Mahajan, Nagpur which has been conferred",
      image: "/aaj-home/certificate4.jpeg ",
    },
      {
      id: 6,
      title: "Indian Concrete Institute, Nagpur Centre & UltraTech Cement Limited",
      date: "2017",
      summary: "ICI(Nagpur)-UltraTech Award for Outstanding Concrete Structure of Vidarbha 2017 under Residential Bungalow Category",
      image: " /aaj-home/certificate5.jpeg",
    },
  ];

 
  return (
    <div className="min-h-screen bg-white">
      {/* Press Releases Section */}
      <section className="py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
           <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#011321] mb-4">Our Awards</h2>
            
               <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6 mb-4"></span>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Celebrating excellence and innovation, our awards recognize the dedication, skill, and achievements that set us apart.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {pressReleases.map((release) => (
              <div
                key={release.id}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border-4  border-gray-400 overflow-hidden"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={release.image}
                    alt={release.title}
                    className="w-full h-56 object-fill group-hover:scale-105 transition-transform duration-300 cursor-pointer"
                    onClick={() => setPreviewImage(release.image)}
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                    <Calendar className="w-4 h-4" />
                    <span>{new Date(release.date).toLocaleDateString('en-US', { 
                      year: 'numeric', 
                      // month: 'long', 
                      // day: 'numeric' 
                    })}</span>
                  </div>
                  
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                    {release.title}
                  </h3>
                  
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                    {release.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

     

      {/* Image Preview Modal */}
      {previewImage && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <div className="relative max-w-3xl w-full mx-4">
            <button
              onClick={() => setPreviewImage(null)}
              className="absolute top-3 right-3 bg-white text-black rounded-full p-2 shadow-lg hover:bg-gray-200"
            >
              ✕
            </button>
            <img
              src={previewImage}
              alt="Preview"
              className="w-full h-auto max-h-[80vh] rounded-lg shadow-lg"
            />
          </div>
        </div>
      )}

      {/* <Footer /> */}
    </div>
  );
};

export default PressPage;
